import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InventoryTransferLineItemTabsComponent } from './inventory-transfer-line-item-tabs.component';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [InventoryTransferLineItemTabsComponent],
  exports: [InventoryTransferLineItemTabsComponent],
  imports: [
    CommonModule,
    MatButtonModule
  ]
})
export class InventoryTransferLineItemTabsModule { }
